import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Lightning(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.679 24a1.87 1.87 0 01-.835-.198 1.878 1.878 0 01-1.04-2.107l1.687-7.468H6.866a1.87 1.87 0 01-1.678-1.063 1.886 1.886 0 01.178-1.938L13.138.758a1.875 1.875 0 012.25-.602 1.878 1.878 0 011.097 2.07l-1.35 7.299h2.982a1.87 1.87 0 011.696 1.063 1.886 1.886 0 01-.224 1.994l-8.494 10.704A1.875 1.875 0 019.678 24zM9.49 12.346a1.87 1.87 0 011.501.69 1.883 1.883 0 01.374 1.614L9.68 22.11l8.438-10.705h-2.982a1.87 1.87 0 01-1.46-.664 1.885 1.885 0 01-.415-1.556l1.378-7.308-7.772 10.469h2.625z",
    fill: props.color || "#222"
  }));
}

var MemoLightning = React.memo(Lightning);
export default MemoLightning;